import { runtimeEnv } from './runtime-env';

export const environment = {
  production: false,
  graphqlUrl: runtimeEnv.apiUrl,
  allowDemoBypass: false,
  campaignFromEmail: 'pgc@customer.bossingvip.com',
  featureFlags: {
    manualLogin: false,
  },
};
